import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { GrnDetailsForReturn } from "./grn-detail-for-return.dto";

export class GrnItemReturnResponse extends GlobalResponseObject {
    data?: GrnDetailsForReturn;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GrnDetailsForReturn) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}